<template>
  <div>
    <van-nav-bar @click-left="onClickLeft" title="提交订单" left-arrow />
    <van-steps :active="active" >
      <van-step>订单确认</van-step>
      <van-step v-if="this.isContract==='1'?true:false">合同签署</van-step>
      <van-step>订单支付</van-step>
      <van-step>服务生效</van-step>
    </van-steps>
    <van-cell-group>
      <van-cell
        :title="title"
        is-link
        v-if="enterpriseLength > 1"
        @click="selectEnterprise"
      />
      <van-cell :title="title" v-if="enterpriseLength==1"/>
    </van-cell-group>

   <div v-for="item in cartList" :key="item.id" class="card-goods__item">
      <van-card
        style="margin-left: 15px"
        :title="item.name"
        :desc="item.commodity"
        :num="item.count"
        :price="item.price"
        :thumb="item.picture"
      >
      </van-card>
    </div>
    <van-submit-bar
      :price="totalPrice"
      :button-text="submitBarText"
      @submit="handleSubmitOrder"
    />
     <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {Indicator} from "mint-ui";
import {
  Card,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Dialog,
  NavBar,
  Picker,
  Popup,
  Step,
  Steps,
  SubmitBar,
  Tabbar,
  TabbarItem,
  Toast,
} from "vant";

export default {
  components: {
    [Card.name]: Card,
     [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Step.name]: Step,
    [Steps.name]: Steps,
  },
  data() {
    return {
      active: 0,
      checkedGoods: [],
      checkeAllCarts: [],
      enterpriseList: [],
      classList: [],
      enterpriseLength: 0,
      cartList: [],
      title: "", //标题信息
      sessionUserInfo: null,
      showPicker: false,
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华", "衢州"],
      enterpriseId: 0,
      message: "",
      totalPriceCount: 0,
      isContract: '0',
    };
  },
  mounted() {

    const url = "/memberBusiness/enterprise/enterpriseList";
    this.$axios
      .get(url)
      .then((data) => {
        this.enterpriseList = data.data;
        if(this.enterpriseList==null){
          this.enterpriseLength=0; 
        }else{
         this.enterpriseLength = this.enterpriseList.length;
        }
        if (this.enterpriseLength == 0) {
          // Toast({
          //   message: "你未设置开票信息",
          //   position: "middle",
          //   duration: 2000,
          // });
          // 
          let that=this;
          Dialog.confirm({
            title: '提示',
            message: '抬头信息，您还没准备好，是否马上填写？',
          })
            .then(() => {
              // on confirm
              that.$router.push({ path: "/headerList" });
            })
            .catch(() => {

               let  goodId= sessionStorage.getItem("goodId");

               that.$router.push({ name: "goods", query: { id: goodId } });
              // on cancel
            });


        } else {
         
          const defaultEnterprise = this.enterpriseList.filter(
            (item) => item.isDefault == "1"
          );

         if (defaultEnterprise.length== 0) {   //如果没有设置默认,随便取一个
            this.title =
              this.enterpriseList[0].corpName +
              "(" +
              this.enterpriseList[0].corpNsrsbh +
              ")";
             this.enterpriseId = this.enterpriseList[0].id; //取第一个信息
          }else{
            this.enterpriseId = defaultEnterprise[0].id; //设置默认ID
            this.title =defaultEnterprise[0].corpName +
              "(" +
              defaultEnterprise[0].corpNsrsbh +
            ")";
          }
        }
      })
      .catch((error) => {
        //请求失败返回的数
        Toast({
          message: error.message,
          position: "middle",
          duration: 2000,
        });
      });
    
  },

  created() {  

    this.init();
   
  
  },
  computed: {
    submitBarText() {
      const count = this.cartList.length;
      return "提交" + (count ? `(${count})` : "");
    },
    totalPrice() {
      let prcount = 0;
      this.cartList.forEach(function (prc) {
        prcount = prcount + prc.price * prc.count;
      });
      return prcount * 100;
    },
  },
  //
  methods: {
    onConfirm(value) {
      this.title = value.text;
      this.enterpriseId = value.id;
      this.showPicker = false;
    },

    selectEnterprise() {
      this.showPicker = true;
      this.columns = [];
      let that = this;
      this.enterpriseList.forEach(function (item) {
        var obj = {};
        obj.text = item.corpName + "(" + item.corpNsrsbh + ")";
        obj.id = item.id;
        that.columns.push(obj);
      });
    },
    onClickLeft() {
      this.$router.push({ path: "/home" });
    },

    init() {
      var s = sessionStorage.getItem("buyData"); //得到存放在session中的购买商品k
      var sessionData = JSON.parse(s);
      this.cartList = [];
      this.cartList = sessionData;
      this.isContract = sessionData[0].isContract==='1'?'1':'0'
      if (s === null) {
        this.$router.push({ path: "/home" });
      }
    },
    handleSubmitOrder() {
      let orderId = sessionStorage.getItem("id") +""+ Date.parse(new Date());
      var updata = [];
      let totalPrice = 0;
      this.cartList.forEach(function (prc) {
        //明细数据
        updata.push({
          quantity: prc.count,
          goodId: prc.id,
        });
        totalPrice = totalPrice + prc.price * prc.count;
      });

      let orderInfoVo = {
        enterpriseId: this.enterpriseId,
        orderZje: totalPrice,
        orderCode: orderId,
        orderDetailsVoList: updata,
        isContract:this.isContract
      };
      var url = "/memberBusiness/order/addOrders";
       Indicator.open({
        text: "提交订单中...",
        spinnerType: "fading-circle"
      });
      setTimeout(() => {
        Indicator.close();
      }, 60000);
      var jump = this.isContract==="1"?"/contractList/":"/payment/";
       this.$axios
        .post(url, orderInfoVo)
        .then((res) => {
          if (res.code == 200) {
            //resolve(res.data);
            this.$router.push({
              path: jump,
              query: { totalPriceCount: totalPrice, orderId: orderId,paymentMode:1,isContract: this.isContract,orderInfoVo: orderInfoVo },
            });
             Indicator.close();
          }else if(res.data == 401){
              Dialog.confirm({
            title: '提示',
            message: '抬头信息，未实名认证，是否马上认证？',
          })
            .then(() => {
              // on confirm
              that.$router.push({ path: "/headerList" });
            })
            .catch(() => {

               let  goodId= sessionStorage.getItem("goodId");

               that.$router.push({ name: "goods", query: { id: goodId } });
              // on cancel
            });
          }else{
                Toast(res.message);
                Indicator.close();
              }
          })
          .catch(err => {
            console.log("错误：", err);
            //reject(false);
             //that.showLoad = false;
              Indicator.close();
          });
    },
  },
};
</script>

<style lang="less" scoped>

* {
  touch-action: none;
}
.content {
  padding: 8px 8px 80px;
}
</style>
